import { DEFAULT_TIMEOUT_MS } from "./consts";

const SOCKET_TIMEOUT_MSG = "Timed out while connecting to socket";
export class SocketTimeoutError extends Error {
  constructor() {
    super(SOCKET_TIMEOUT_MSG);
  }
}

export type SocketEvent = string;

export type SocketEventHandler = (...args: any[]) => void;

export type Subscriber = (data: any) => void;

export interface IControlSource {
  subscribe: (event: SocketEvent, handler: Subscriber) => void;
  unsubscribe: (event: SocketEvent, handler: Subscriber) => void;
  send: (event: SocketEvent, data?: object) => void;
  onDisconnect: (cb: SocketEventHandler) => void;
  onConnect: (cb: SocketEventHandler) => void;
  onError: (cb: SocketEventHandler) => void;
  isConnected: () => boolean;
  close: () => void;
}

export type SocketTimeoutHelperOptions = {
  timeoutMs?: number;
};

export class ControlSourceTimeoutHelper {
  errorHandlers: Array<SocketEventHandler>;
  controlSource: IControlSource;
  timeoutId: number | null | NodeJS.Timeout;
  timeoutMs: number;
  constructor(
    controlSource: IControlSource,
    { timeoutMs = DEFAULT_TIMEOUT_MS }: SocketTimeoutHelperOptions = {}
  ) {
    this.errorHandlers = [];
    this.controlSource = controlSource;
    this.timeoutId = null;
    this.timeoutMs = timeoutMs;
  }
  schedule(timeoutMs = DEFAULT_TIMEOUT_MS) {
    this.timeoutId = setTimeout(() => {
      for (const handler of this.errorHandlers) {
        handler(new SocketTimeoutError());
      }
      this.controlSource.close();
    }, timeoutMs);
  }
  cancel() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  onTimeout(cb: SocketEventHandler) {
    this.errorHandlers.push(cb);
  }
}
